import {
  countries
} from '../helpers/countries';
import {
  applicantFields,
  studentNumberFields,
  legalGuardianFields
} from '../helpers/fields';

import * as fieldGroups from '../helpers/fieldGroups';

const clientName = 'ubcimedblanket';

export function expandedGroups() {
  return [
    fieldGroups.policyGroup(clientName, 'Referrer'),
    fieldGroups.primaryApplicantDetailsGroup(clientName),
    fieldGroups.emailNotificationGroup(),
    fieldGroups.feeRefundGroup(),
    fieldGroups.contactDetailsGroup(clientName),
    fieldGroups.dependentDetailsGroup(clientName),
    fieldGroups.coverageDetailsGroup(clientName),
    fieldGroups.pmqGroup(),
    fieldGroups.paymentGroup(clientName),
    fieldGroups.historyGroup(),
    fieldGroups.notesGroup(),
  ];
}

export function fields() {
  return {
    primary_applicant_fields: [
      {
        key_path: ['application', 'additional_data', 'school_name'],
        as: 'School'
      },
      ...studentNumberFields('0'),
      {
        key_path: ['application', 'associated_policy'],
        as: 'Associated Student Policy',
        do_not_show_if: [{
          key_path: ['application', 'associated_policy'],
          value: null
        }],
        is_static_by_default: false
      },
      {
        key_path: ['applicant', '0', 'additional_data', 'relationship_to_student'],
        as: 'Relationship to Student',
        do_not_show_if: [{
          key_path: ['application', 'associated_policy'],
          value: null
        }],
        is_static_by_default: false,
        type: 'dropdown',
        options: [
          { value: 'parent', text: 'Parent/Guardian' },
          { value: 'dependent', text: 'Dependent Child' },
          { value: 'spouse', text: 'Spouse' },
          { value: 'teacher', text: 'Teacher' },
          { value: 'chaperone', text: 'Chaperone' }
        ]
      }
    ],
    contact_details_fields: [
      ...legalGuardianFields(true)
    ],
    dependent_fields: [
      ...applicantFields('*', [{
        value: 'dependent',
        text: 'Dependent Child'
      },
      {
        value: 'parent',
        text: 'Parent/Guardian'
      },
      {
        value: 'spouse',
        text: 'Spouse'
      },
      {
        value: 'sibling',
        text: 'Sibling'
      }
      ]),
      ...studentNumberFields('*'),
    ],
    coverage_fields: [
      {
        key_path: ['application', 'additional_data', 'country_of_origin'],
        as: 'Home Country',
        type: 'dropdown',
        options: countries()
      },
      {
        key_path: ['application', 'additional_data', 'destination'],
        as: 'Destination',
        type: 'dropdown',
        options: [
          ...countries(),
          {
            text: 'Worldwide',
            value: 'WW'
          }
        ]
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/clients/ubcimedblanket.js